import { useEffect } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchParticipantApplications = (userID) => {
  const { apiGet } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const fetchData = async () => {
    if (!userID) return;
    startLoading();
    const response = await apiGet(`/aplicaciones/show_participant_applications`, "Error al obtener las aplicaciones", { user_id: userID });
    setResponse(response);
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userID]);

  return { data, error, loading, refetch: fetchData };
};

export default useFetchParticipantApplications;
